import { InvoiceDocumentType } from '../enums/invoiceDocumentType'
import { SalesDocumentPropsByListingType } from '../types/salesDocument/salesDocumentPropsByListingType'
import { SalesListingDocumentType } from '../types/salesDocument/salesListingDocumentType'

type SalesListingDocumentTypeToQueryDocumentTypes<T extends SalesListingDocumentType> =
  SalesDocumentPropsByListingType[T]['documentTypes']

type SalesDocumentTypeQueryMap = {
  [T in SalesListingDocumentType]: SalesListingDocumentTypeToQueryDocumentTypes<T>
}

const salesListingDocumentTypeToQueryParams = {
  invoices: [InvoiceDocumentType.Invoice, InvoiceDocumentType.InvoiceDraft, InvoiceDocumentType.CreditNote],
  quotes: [InvoiceDocumentType.Quote, InvoiceDocumentType.QuoteDraft],
} satisfies SalesDocumentTypeQueryMap

export function getSalesQueryDocumentTypes<T extends SalesListingDocumentType>(type: T) {
  return salesListingDocumentTypeToQueryParams[type] as SalesListingDocumentTypeToQueryDocumentTypes<T>
}
